export const translations = {
	'Trigger type': {
		no: 'Triggertype',
	},
	'Are you sure you want to remove these profiles?': {
		no: 'Vil du slette profilene',
	},
	'Are you sure you want to remove this profile?': {
		no: 'Vil du slette profilen',
	},
	'Profile successfully deleted': {
		no: 'Profil er slettet',
	},
	'Profiles successfully deleted': {
		no: 'Profilene er slettet',
	},
	'This is a shared script and is readonly by default. In order to edit the shared script click “Edit Shared script” in the menu. The modification will affect all places script is used. To edit the script within this configuration. Click “Unlink script”. This will make the script in static and editable in this configuration.':
		{
			no: 'Dette er et delt skript og kun lesbart. For å redigere det må du klikke på “Rediger delt skript“ i menyen. Endringer vil gjelde all profiler hvor dette skriptet er brukt. For å kun redigere dette skriptet klikk “Avlink script”. Det medfører at dette skriptet ikke er delt i andre profiler og kan redigeres for gjeldende profil.',
		},
	'To test action script select agent in dropdown and click test button': {
		no: 'For å teste actionskriptet velg en agent og klikk test knappen',
	},
	'To test datasource script select agent in dropdown and click test button': {
		no: 'For å teste datakildeskript velg en agent og klikk test knappen',
	},
	'Share script': {
		no: 'Del skript',
	},
	'Link script': {
		no: 'Link skript',
	},
	'Unlink script': {
		no: 'Avlink skript',
	},
	'Edit shared script': {
		no: 'Rediger delt skript',
	},
	'Returned data': {
		no: 'Returnert data',
	},
	'Click a row in summary grid to display returned data': {
		no: 'Klikk en rad i sammendragstabellen for å vise returnert data',
	},
	'Please fill in action script': {
		no: 'Skriv inn action skript',
	},
	'Test results from ': {
		no: 'Testresultat fra ',
	},
	'No data returned': {
		no: 'Ingen data ble returnert',
	},
	'Script type: ': {
		no: 'Skript: ',
	},
	'Message: ': {
		no: 'Melding: ',
	},
	'Details: ': {
		no: 'Detaljer: ',
	},
	'You have unsaved content in script editor. You will lose the changes if you click Close. Click Cancel and save the changes if you want to keep the changes.':
		{
			no: 'Du har ulagret innhold i profilen, du vil miste endringen hvis du klikker Lukk. Trykk avbryt og lagre endringen hvis du vil beholde endringene.',
		},
	'Run details': {
		no: 'Detaljer fra kjøring',
	},
	'Input script name': {
		no: 'Sett inn navn på skriptet',
	},
	'actionscript': {
		no: 'handlingsskript',
	},
	'datasource script': {
		no: 'datakildeskript',
	},
};
